import {Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {NavComponent} from '../../templates/header-template/nav/nav.component';
import {MenuItem} from 'primeng/api';
import { NgFor, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css'],
    imports: [NgFor, NgIf, ButtonDirective, RouterLink]
})
export class HomePageComponent{

	menuItems: MenuItem[];

	constructor(public navComponent: NavComponent, private translateService: TranslateService) {
		this.menuItems = navComponent.menuItems;
		this.translateService.onLangChange.subscribe(event => this.menuItems = navComponent.menuItems);
	}
}

